import React from "react";
import { TableRow, TableCell, Avatar, Stack, IconButton } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import StatusChip from "./StatusChip";

export default function OrderRow({ order, srNo, onMenuOpen }) {
  return (
    <TableRow hover>
      <TableCell>{srNo}</TableCell>
      <TableCell>{order.id}</TableCell>
      <TableCell>
        <Stack direction="row" spacing={1} alignItems="center">
          <Avatar sx={{ width: 28, height: 28 }} />
          {order.name}
        </Stack>
      </TableCell>
      <TableCell>{order.email}</TableCell>
      <TableCell>{order.contact}</TableCell>
      <TableCell>{order.payment_gateway}</TableCell>
      <TableCell>{order.amount}</TableCell>
      <TableCell>{order.currency}</TableCell>
      <TableCell>
        <StatusChip status={order.status} />
      </TableCell>
      <TableCell>{new Date(order.createdAt).toLocaleDateString()}</TableCell>
      <TableCell>
        <IconButton onClick={(e) => onMenuOpen(e, order)}>
          <MoreVertIcon />
        </IconButton>
      </TableCell>
    </TableRow>
  );
}
